import { computed, set } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import type { ChapterThemeDefaults } from '@/composables/payment'
import { STORAGE_CUSTOM_THEME } from '@/constants'
import { clamp } from '@/utils'

/**
 * 主题管理 Composable
 * 管理阅读器的主题颜色和字体大小设置
 */

// 字体大小映射表 (14 个选项)
export const THEME_FONT_MAP = ['24', '26', '28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50']

// 主题背景颜色 (6 种)
export const THEME_BACKGROUNDS = ['#F6F7F9', '#D5E9D4', '#CEE7FF', '#FFE1DC', '#FBE6B5', '#292929']

export function useChapterTheme(defaults?: ChapterThemeDefaults) {
  // 从 localStorage 读取主题设置,使用品牌默认值或通用默认值
  const theme = useLocalStorage(STORAGE_CUSTOM_THEME, {
    background: defaults?.background || '#F6F7F9',
    size: defaults?.size || '38',
  })

  // 计算字体样式
  const THEME_FONT = computed(() => {
    // 确保字体大小在有效范围内
    if (!THEME_FONT_MAP.includes(theme.value.size))
      set(theme.value, 'size', '38')

    const fontSize = Number.parseInt(theme.value.size)

    return {
      chapterTitle: `font-size: ${fontSize / 2 + 2}px;font-weight: 500;`,
      chapterContent: `margin-top: 1em;font-size: ${fontSize / 2}px;line-height: 1.7em;`,
      leadSentence: `font-size: ${fontSize / 2 - 1}px;line-height: 1.7em;`,
      paragraphSpacing: 'margin-top: 1em;',
    }
  })

  /**
   * 改变字体大小
   * @param zoom 缩放方向 (1: 放大, -1: 缩小)
   */
  function onChangeThemeSize(zoom: number) {
    const currentIndex = THEME_FONT_MAP.indexOf(theme.value.size)
    const newIndex = clamp(currentIndex + zoom, 0, THEME_FONT_MAP.length - 1)
    set(theme.value, 'size', THEME_FONT_MAP[newIndex])
  }

  /**
   * 设置背景颜色
   * @param color 背景颜色值
   */
  function setBackground(color: string) {
    if (THEME_BACKGROUNDS.includes(color))
      theme.value.background = color
  }

  return {
    theme,
    THEME_FONT,
    THEME_FONT_MAP,
    THEME_BACKGROUNDS,
    onChangeThemeSize,
    setBackground,
  }
}
